import { Button } from "@/view/components/ui/button";
import { CircleDollarSign } from "lucide-react";
import masks from "@/app/utils/masks";
import { format, isToday, isYesterday, parseISO } from "date-fns";
import { ptBR } from "date-fns/locale";
import { Link } from "iconsax-react";

type Lead = {
  _id: string;
  name: string;
  cpf: string;
  phone: string;
  linkName?: string;
  availableBalance: number;
  createdAt: string;
};

type Props = {
  lead: Lead;
  contacted: boolean;
  onContactClick?: () => void;
  isLast?: boolean;
  onClick?: () => void;
};

export const LeadList = ({
  lead,
  contacted,
  onContactClick,
  isLast,
  onClick,
}: Props) => {
  const formatDate = (dateString: string) => {
    const date = parseISO(dateString);

    if (isToday(date)) return "Hoje";
    if (isYesterday(date)) return "Ontem";

    return format(date, "dd/MM", { locale: ptBR });
  };

  return (
    <>
      <div
        className={`cursor-pointer border-l-[3px] px-2 py-1 ${
          contacted ? "border-l-gray01" : "border-l-primary"
        }`}
        onClick={onClick}
      >
        <div className="flex items-center justify-between gap-2">
          <div className="flex flex-col gap-1">
            <p
              className={`text-[14px] ${
                contacted ? "font-normal" : "font-bold"
              } text-black`}
            >
              {lead.name || masks.cpf(lead.cpf)}
            </p>

            <div className="flex flex-wrap items-center gap-2">
              <div
                className={`flex items-center gap-1 rounded-full border border-gray01 px-3 py-1 ${
                  contacted ? "text-black04" : ""
                }`}
              >
                <CircleDollarSign size={14} />
                <p className="text-[12px]">
                  R$ {masks.currency(lead.availableBalance)}
                </p>
              </div>

              {lead.linkName && (
                <div className="flex items-center gap-1">
                  <Link size={14} color={contacted ? "#9F9F9F" : "#2F80ED"} />
                  <p
                    className={`text-[12px] ${
                      contacted ? "text-black04" : "text-[#2F80ED]"
                    }`}
                  >
                    {lead.linkName}
                  </p>
                </div>
              )}

              <p
                className={`text-[12px] ${
                  contacted ? "text-black04" : "text-black"
                }`}
              >
                {formatDate(lead.createdAt)}
              </p>
            </div>
          </div>
          <Button
            className="flex items-center justify-center gap-2 rounded-full bg-white shadow-[0_0_10px_rgba(0,0,0,0.1)] hover:bg-white"
            onClick={(e) => {
              e.stopPropagation();
              onContactClick?.();
            }}
            disabled={contacted}
          >
            <p className="font-bold text-black">Contatar</p>
            <img src="/whatsapp_green.svg" alt="icone whatsapp" />
          </Button>
        </div>
      </div>
      {!isLast && <div className="h-[1px] w-full bg-gray01" />}
    </>
  );
};
